module.exports = __webpack_public_path__ + "d8f22b99655e1fd7e6efcba3145a3c8f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/rollerskates-blackred.png
// module id = 2414
// module chunks = 0